import { makeStyles } from "@material-ui/core"

const homepagePlatforms = makeStyles({
    root: {
        backgroundColor: "#212121",
    }
})

export { homepagePlatforms };